import dateService from '@gem/services/date-service';

import { Schedule } from 'STORE/Groups/Schedule';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { MessageError } from 'STORE/Messages/Message/ChatMessage/ChatMessages.types';

import { sendScheduledMessage } from '../createScheduledMessage/sendScheduledMessage';

export function rescheduleMessage(message: ChatMessage): void {
  if (!(message.group instanceof Schedule)) {
    return;
  }

  const nowTime = dateService.now().getTime();

  message.resetError();
  sendScheduledMessage({
    groupId: message.group.groupId!,
    message,
    delay: message.serverTime - nowTime,
    callback: (result: boolean): void => {
      if (!result) {
        message.setError(MessageError.Schedule);
      }
    },
  });
}
